export const ItemTypes = {
    LOCATION: 'location',
    SCENE_SETTING: 'sceneSetting'
}